import { render, staticRenderFns } from "./comp_CarouselBook.vue?vue&type=template&id=2ebad500&scoped=true&"
import script from "./comp_CarouselBook.vue?vue&type=script&lang=js&"
export * from "./comp_CarouselBook.vue?vue&type=script&lang=js&"
import style0 from "./comp_CarouselBook.vue?vue&type=style&index=0&id=2ebad500&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebad500",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
